import { Box, Skeleton, Stack } from "@mui/material";
import { List, Title } from "@src/appV2/redesign/system/ui-components";

import { BottomSheetHeader } from "../../../components/BottomSheetHeader";

interface SelectionSheetSkeletonProps {
  onBack: () => void;
}

export function SelectionSheetSkeleton(props: SelectionSheetSkeletonProps) {
  const { onBack } = props;

  return (
    <>
      <Stack>
        <BottomSheetHeader onBack={onBack} />
        <Stack sx={{ paddingX: 6, paddingTop: 5, paddingBottom: 8, alignItems: "center" }}>
          <Title variant="h3" component="h2">
            <Skeleton variant="text" width={200} />
          </Title>
        </Stack>
      </Stack>

      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <List
          sx={{
            paddingX: 6,
            paddingBottom: 5,
            gap: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {[1, 2, 3].map((index) => (
            <Box
              key={index}
              sx={(theme) => ({
                paddingX: 5,
                paddingY: 4,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: theme.shape?.borderRadius ?? 2,
                backgroundColor: theme.palette.common.white,
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
              })}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack spacing={1}>
                  <Skeleton variant="text" width={120} height={20} />
                  <Skeleton variant="text" width={180} height={16} />
                </Stack>
                <Skeleton variant="text" width={60} height={24} />
              </Stack>
            </Box>
          ))}
        </List>
      </Box>
    </>
  );
}
